import React, {useState} from "react";
import { useHistory } from "react-router-dom";
import { useSelector} from 'react-redux';
import moment from 'moment';
import 'moment/locale/bg';  // without this line it didn't work
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {findLastUnpaidCashflow, isPolicyAdded, generateAddressString, countDaysPastDueDate}  from '../../../../../app/common/services/vehicle.service';
import { downloadFile } from "../../../../../app/common/services/fetch.service";
import {DeliveryIcon, DolwnloadIcon, CashIcon} from '../../../../pages/components/svg/iconsSvg';
import { DoubleTickIcon } from '../../../../pages/components/svg/iconDashSvg';
import {paymentType} from '../../../../../app/common/types/paymentTypes'
import CustomDrawer from '../../../../pages/components/elements/CustomDrawer';
import DeliveryProgress from '../elements/DeliveryProgress';

const CashFlowDetails = ({policy, cashflow}) => {
    const history = useHistory();

    const {userAddresses} = useSelector(state => state.userDetails) || {};

    const dueDate =  moment(cashflow?.dueDate).format('DD.MM.YYYY');
    let payAmount =  Number.parseFloat(cashflow?.dueAmount).toFixed(2);
        payAmount = Number.isNaN(parseInt(payAmount)) ? null : payAmount;

    let payAmountEUR =  Number.parseFloat(cashflow?.dueAmountEUR).toFixed(2);
        payAmountEUR = Number.isNaN(parseInt(payAmountEUR)) ? null : payAmountEUR;
        
    const unpaidCashFlow = findLastUnpaidCashflow(policy?.cashflows);

    console.log(unpaidCashFlow, 'test')
    
    const isLastUnpaid = unpaidCashFlow?.cashflowId === cashflow?.cashflowId;

    const isBeforeLastUpaid = unpaidCashFlow?.cashflowId > cashflow?.cashflowId;

    const shipmentDetails = policy?.deliveries ? policy?.deliveries.find(obj => obj.cashflowId === cashflow?.cashflowId) : null;

    const isCashOnDelivery = cashflow?.paymentType === paymentType.cashOnDelivery;

    const deliveryAddress = userAddresses ? userAddresses.find(obj=>obj.addressId === shipmentDetails?.addressId) : null;

    const daysPastDueDate = countDaysPastDueDate(policy?.cashflows);

    const isPolicyCanceled = daysPastDueDate < -15;

    const unablePayment = isLastUnpaid && policy?.status === 'ACTIVE';

    const [open, setOpen] = useState(false);
    const [showProgress, setShowProgress] = useState(false);

    const handleOpen = () => {
        setOpen(!open);
      };

    const onShowProgress = (event) => {
        event.stopPropagation();
        setShowProgress(true);
    }
    
    const hideProgress = () => setShowProgress(false);

    const payInstallment = () => {
        history.push(`/app/pay-installment/${policy.insuranceId}`);
    }

    const downloadReceipt = () => {
        if(!policy?.insuranceDocuments) return;
        const doc = policy?.insuranceDocuments.find(doc => (doc.cashflowId === cashflow?.cashflowId && doc.docType === "RECEIPT"));
        const fileUploadId = doc ? doc.fileUploadId : null;
        if(!fileUploadId) return;
        const contentType = doc?.contentType;
        const fileName = contentType === "application/pdf" ? 'Receipt.pdf': 'Receipt.png';

        downloadFile(fileUploadId).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); //or any other extension
            document.body.appendChild(link);
            link.click();
        });
    }

    const renderSecondRow = () => {
        if(isPolicyAdded(policy) && !deliveryAddress) return <></>

        const isDelivered = shipmentDetails?.shipmentStatus === 'DELIVERED';

        if(cashflow?.paid ) {
            return  <div className="second-row">
                        <div className="item">
                            <DoubleTickIcon size={18}/>
                            <p className="text green">Платена</p>
                        </div>
                        {isDelivered || isCashOnDelivery
                        ?   <div className="item">
                                <DeliveryIcon size={22}/>
                                <p className="text green">Доставена</p>
                            </div>
                        :   <div className="item link" onClick={(event)=>onShowProgress(event)}>
                                <DeliveryIcon color={'#2755cc'} size={22}/>
                                <p className="text blue">Проследи пратка</p>
                            </div>
                        }
                        <div className="item link">
                            <DolwnloadIcon size={16}/>
                            <p className="text blue" onClick={downloadReceipt}>Квитанция</p>
                        </div>
                    </div>
        } else if (!cashflow?.paid && isCashOnDelivery) {
            return <div className="second-row">
                        <div className="item">
                            <CashIcon />
                            <p className="text red">Очаква плащане</p>
                        </div>
                        <div className="item">
                            <DeliveryIcon color={'#2755cc'} size={22}/>
                            <p className="text blue">В процес на обработка</p>
                        </div>
                    </div>
        }
    }

    const renderThirdRow = () => {
        const paymenttDate = moment(cashflow?.paidDate).format('DD.MM.YYYY');
        const receiverName = shipmentDetails?.receiverName ? shipmentDetails?.receiverName : null;
        const receiverPhone = shipmentDetails?.receiverPhone ? shipmentDetails?.receiverPhone : null;
        const address = deliveryAddress ? generateAddressString(deliveryAddress) : <>&nbsp;</>;
        let paidNotes = cashflow?.paidNotes ? cashflow?.paidNotes : <>&nbsp;</>;
        paidNotes = isCashOnDelivery ? 'Наложен платеж' : paidNotes;
        return <div className="third-row">
                    <div className="item left">
                        <p>Дата на плащане</p>
                        <p>Карта </p>
                        <p>Доставка</p>
                    </div>
                    <div className="item right">
                        <p>{paymenttDate ? paymenttDate : <>&nbsp;</>} </p>
                        <p>{paidNotes}</p>
                        <div className="item right" style={{marginTop: '.5rem'}}>
                            <p>{receiverName}</p>
                            <p>{receiverPhone}</p>
                            <p>{address}</p>
                        </div>
                    </div>
                </div>
    }

    const renderBeforeLastUnpaid = () => {
        return <>
                <div className="cashflow-details" >
                    <List>
                        <ListItem button onClick={handleOpen}>
                        <div className="first-row-paid" >
                            <div>{cashflow?.cashflowId} вноска</div>
                            <div>{dueDate}</div>
                            <p > {payAmountEUR} € / {payAmount} лв.</p>
                        </div>
                            {open ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <ListItem>
                            {renderSecondRow()}
                        </ListItem>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {renderThirdRow()}
                        </Collapse>
                    </List>
                </div>
                
                <CustomDrawer show={showProgress} close={hideProgress} headerText="Проследяване на пратка">
                    <div className="progress-container">
                        <DeliveryProgress shipmentDetails={shipmentDetails}/>
                    </div>
                </CustomDrawer>
        </>
    }

    return isBeforeLastUpaid
            ? renderBeforeLastUnpaid()
            : <div className="cashflow-details" >
                <div className="first-row" >
                    <div>{cashflow?.cashflowId} вноска</div>
                    <div>{dueDate}</div>
                    <div>
                        <p style={{marginBottom: '16px'}}>{payAmountEUR} € / {payAmount} лв.</p>
                    </div>
                </div>
                { unablePayment && !isPolicyCanceled
                    ? <div className="second-row-btn" >
                        <button className="nuIns-btn nuIns-btn-main" style={{ marginRight: '0'}}
                                disabled={!unablePayment}
                                onClick={payInstallment}>Плащане</button>
                    </div>
                    : isPolicyCanceled
                    ? <p className="red">Прекратена</p>
                    : <></>
                }
            </div>
}

export default CashFlowDetails;